import createApiClient from './apiClient';

// The student-service URL is ".../api/students"; the monitor proxy lives at the
// service root under "/api/doc-service/*".
const STUDENT_URL = process.env.REACT_APP_ATHENIAN_STUDENT_SERVICE_URL || '';
const ROOT = STUDENT_URL.replace(/\/api\/students\/?$/, '');

const monitoringApi = createApiClient(ROOT);

export const getPipelineStatus = () =>
  monitoringApi.get('/api/doc-service/pipeline-status');

export const getPipelineTraces = (limit = 200) =>
  monitoringApi.get('/api/doc-service/pipeline-traces', { params: { limit } });

export const getPipelineAudit = (params = {}) =>
  monitoringApi.get('/api/doc-service/pipeline-audit', { params });

export const clearPipelineRecords = () =>
  monitoringApi.delete('/api/doc-service/pipeline-records');
